angular.module('impactx.cancellation').controller('CancelAllCtrl', ['$scope',
    'dataGen',
    'ToastService',
    '$route',
    'TranslationService',
    'themeFactory',
    '$mdDialog',
    'selectedEntries',
    CancelAllCtrl]);

function CancelAllCtrl($scope, dataGen, ToastService, $route, TranslationService, themeFactory, $mdDialog, selectedEntries) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {}, '/purchaserequest/cancellation/viewcancelall');

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.save = function(event) {
        var dataObject = {selected: selectedEntries, reason: $scope.data.selected.id};
        $mdDialog.cancel();

        dataGen.post($scope, dataObject, '/purchaserequest/cancellation/savecancelall').then(function() {
            $route.reload();
            ToastService.openStandardToast($scope.trns.success);
        });
    }
}